import React, { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useSupportAccess from '../use-support-access';
import { useSupportStore } from '../state/use-support-store';
import Composer from './Composer';
import MessageList from './MessageList';
import ResidentCard from './ResidentCard';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ThreadActions from './ThreadActions';

const ChatPane = ({ onBack, canWrite }) => {
  const { engineerId } = useSupportAccess();
  const { thread, threadLoading, threadError, selectedId, updatingStatus, changeStatus } = useSupportStore();
  const [showCard, setShowCard] = useState(false);

  if (!selectedId && !threadLoading) {
    return <div className="flex flex-1 items-center justify-center text-sm text-gray-500">Выберите обращение</div>;
  }

  if (threadLoading && !thread) return <LoadingSpinner loading style="flex flex-1 items-center justify-center" />;

  if (!thread) {
    return (
      <div className="flex flex-1 items-center justify-center px-6 text-center text-sm text-red-500">{threadError?.error || 'Не удалось открыть чат'}</div>
    );
  }

  const isMine = Boolean(thread.assignee) && String(thread.assignee.engineer_id) === String(engineerId ?? '');
  const assignedToOther = Boolean(thread.assignee) && !isMine;
  const closed = thread.status === 'closed';

  return (
    <div className="relative flex min-w-0 flex-1 flex-col bg-white">
      <header className="flex flex-col gap-2 border-b border-gray-200 bg-white px-3 py-3">
        <div className="flex items-center gap-2">
          <button type="button" aria-label="К списку" onClick={onBack} className="rounded-full p-1 text-gray-500 hover:bg-gray-100 md:hidden">
            <ArrowBackIcon />
          </button>
          <div className="min-w-0 flex-1">
            <p className="truncate text-base font-medium text-gray-900">{thread.user?.fio || 'Без имени'}</p>
            {thread.assignee?.fio ? <p className="truncate text-xs text-gray-500">В работе: {thread.assignee.fio}</p> : null}
          </div>
        </div>

        <ThreadActions
          status={thread.status}
          canWrite={canWrite}
          closed={closed}
          isMine={isMine}
          updatingStatus={updatingStatus}
          onShowCard={() => setShowCard(true)}
          onChangeStatus={changeStatus}
        />
      </header>

      {canWrite && !closed && assignedToOther ? (
        <p className="bg-amber-50 px-4 py-2 text-sm text-amber-800">Чат в работе у {thread.assignee.fio}. Можно ответить, сообщение уйдёт от вашего имени.</p>
      ) : null}

      <MessageList />

      {canWrite && !closed ? <Composer threadId={thread.id} /> : null}
      {closed ? (
        <p className="border-t border-gray-200 px-4 py-3 text-center text-sm text-gray-500">Обращение закрыто. История доступна для просмотра.</p>
      ) : null}

      <ResidentCard open={showCard} onClose={() => setShowCard(false)} />
    </div>
  );
};

export default ChatPane;
